
// cart-drawer-detection-and-recheck.js
(function () {
  // debounce helper
  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // --- recheckBadges: replicate the safe, non-destructive badge-check logic ---
  function recheckBadges() {
    try {
      const badgeWrappers = document.querySelectorAll(".product-badge-wrapper");

      badgeWrappers.forEach(wrapper => {
        const startDateStr = wrapper.dataset.start;
        const endDateStr = wrapper.dataset.end;
        const badgeEl = wrapper.querySelector(".product-badge");

        if (!startDateStr || !endDateStr || !badgeEl) return;

        const startDate = new Date(startDateStr).getTime();
        const endDate = new Date(endDateStr).getTime() + 24 * 60 * 60 * 1000; // include full end date
        const oneDayMs = 24 * 60 * 60 * 1000;

        const now = new Date().getTime();
        const diffMs = endDate - now;

        if (now < startDate) {
          badgeEl.textContent = ""; // Not started yet
          return;
        }

        if (diffMs <= 0) {
          badgeEl.textContent = "Expired";
          if (badgeEl.parentElement) badgeEl.parentElement.className = "product-badge-wrapper product-badge--expired";
          return;
        }

        const todayStr = new Date(now).toISOString().split("T")[0];
        const startStr = new Date(startDate).toISOString().split("T")[0];
        const endStr = new Date(endDate - oneDayMs).toISOString().split("T")[0];

        const daysLeft = Math.ceil(diffMs / oneDayMs);

        if (todayStr === startStr) {
          
          badgeEl.textContent = "Limited time";
          badgeEl.className = "product-badge product-badge--active";

        } else if (todayStr === endStr) {

          const hours = Math.floor((diffMs % oneDayMs) / (1000 * 60 * 60));
          const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);
          badgeEl.textContent = `⏰ Sale Ends In (${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")})`;
          badgeEl.className = "product-badge product-badge--warning";

        } else if (daysLeft === 2) {

          badgeEl.textContent = "⏰ 1 day left for Sale";
          badgeEl.className = "product-badge product-badge--1-day-info";

        } else if (daysLeft > 2) {

          const endDateObj = new Date(endDate - oneDayMs);
          const options = { year: 'numeric', month: 'short', day: 'numeric' };
          badgeEl.textContent = `⏰ Sale Ends ${endDateObj.toLocaleDateString(undefined, options)}`;
          badgeEl.className = "product-badge product-badge-all-info ";

        }
      });
    } catch (err) {
      // never break the site
      console.warn('recheckBadges error', err);
    }
  }
  // --- end recheckBadges ---

  const debouncedRecheck = debounce(recheckBadges, 150);

  // run on load immediately
  document.addEventListener('DOMContentLoaded', recheckBadges);

  // run on resize (debounced)
  window.addEventListener('resize', debouncedRecheck);

  // Try a broad set of cart-related events (themes/apps use different names)
 const cartEvents = [
    "cart:updated", "cart:update", "cart.updated", "cart.open", "cart:open",
    "cart:refresh", "cart:change", "ajaxCart.afterUpdate", "ajaxCart:afterRender",
    "cart.ajax:afterUpdate", "drawer:open", "drawer:opened",
    "quick-add:open", "quick-add:opened", "quick-add:updated"
  ];
  cartEvents.forEach(evt => {
    try {
      document.addEventListener(evt, function () {
        // small delay so drawer DOM has time to appear
        setTimeout(recheckBadges, 250);
      });
    } catch (e) { /* ignore */ }
  });

  // Watch for form submits / add-to-cart button clicks (delegated)
  document.addEventListener('submit', function (e) {
    try {
      const form = e.target;
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
        setTimeout(recheckBadges, 300);
      }
    } catch (err) { /* ignore */ }
  });

  document.addEventListener('click', function (e) {
    try {
      const btn = e.target.closest ? e.target.closest('button, a, input[type="submit"]') : null;
      if (!btn) return;
      const form = btn.closest ? btn.closest('form') : null;

      // common heuristics for add-to-cart buttons/controls
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
        setTimeout(recheckBadges, 350);
        return;
      }

      if (btn.dataset && (btn.dataset.addToCart !== undefined || btn.dataset.ajaxAdd !== undefined || btn.dataset.shopify === 'add')) {
        setTimeout(recheckBadges, 350);
      }
    } catch (err) { /* ignore */ }
  });

  // Monkey-patch fetch to detect cart-related requests
  try {
    if (window.fetch) {
      const _fetch = window.fetch;
      window.fetch = function (...args) {
        return _fetch.apply(this, args).then(res => {
          try {
            const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
            if (url && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart.js') !== -1 || url.indexOf('/cart/change') !== -1)) {
              setTimeout(recheckBadges, 250);
            }
          } catch (e) { /* ignore */ }
          return res;
        });
      };
    }
  } catch (err) { /* ignore */ }

  // Monkey-patch XHR to catch legacy ajax adds
  try {
    const XProto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (XProto) {
      const oldOpen = XProto.open;
      XProto.open = function (method, url) {
        try {
          this.__requestedURL = url;
        } catch (e) { }
        return oldOpen.apply(this, arguments);
      };
      const oldSend = XProto.send;
      XProto.send = function (body) {
        this.addEventListener && this.addEventListener('load', function () {
          try {
            const url = this.__requestedURL || '';
            if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart.js') !== -1 || url.indexOf('/cart/change') !== -1) {
              setTimeout(recheckBadges, 250);
            }
          } catch (e) { /* ignore */ }
        });
        return oldSend.apply(this, arguments);
      };
    }
  } catch (err) { /* ignore */ }

  // MutationObserver: watch for cart drawer nodes appearing or their attributes changing (visibility)
  try {
     const drawerSelectors = [
      ".cart-drawer", "#cart-drawer", ".ajaxcart", ".ajax-cart", ".drawer--cart",
      "[data-cart-drawer]", ".drawer[data-drawer=\"cart\"]", ".cart-drawer-wrapper",
      ".quick-add-drawer", "#quick-add-drawer", "[data-quick-add-drawer]"
    ];

    function isVisible(el) {
      if (!el) return false;
      if (el.hasAttribute && el.hasAttribute('aria-hidden')) {
        if (el.getAttribute('aria-hidden') === 'false') return true;
      }
      if (el.offsetParent !== null) return true;
      const cs = getComputedStyle(el);
      return (cs && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0);
    }

    // Observe a drawer element for attribute changes
    function observeDrawer(el) {
      if (!el || el.__cartObserver) return;
      el.__cartObserver = new MutationObserver(debounce(function (mutations) {
        try {
          if (isVisible(el)) {
            setTimeout(recheckBadges, 150);
          }
        } catch (e) { /* ignore */ }
      }, 100));
      el.__cartObserver.observe(el, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'], subtree: true, childList: true });
    }

    // Initial scan for existing drawers
    drawerSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        observeDrawer(el);
        if (isVisible(el)) setTimeout(recheckBadges, 150);
      });
    });

    // Observe body for new drawer nodes injected later
    const bodyObserver = new MutationObserver(debounce(function (mutations) {
      mutations.forEach(m => {
        m.addedNodes && m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          drawerSelectors.forEach(sel => {
            try {
              if (node.matches && node.matches(sel)) {
                observeDrawer(node);
                if (isVisible(node)) setTimeout(recheckBadges, 150);
              } else {
                // maybe drawer is nested inside the added node
                const found = node.querySelector && node.querySelector(sel);
                if (found) {
                  observeDrawer(found);
                  if (isVisible(found)) setTimeout(recheckBadges, 150);
                }
              }
            } catch (e) { /* ignore */ }
          });
        });
      });
    }, 200));
    bodyObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
  } catch (err) { /* ignore */ }

  // last-resort: periodic quick check for a short time after page load (to catch edge-case app-injected drawers)
  try {
    let tries = 0;
    const poll = setInterval(function () {
      recheckBadges();
      tries++;
      if (tries > 8) clearInterval(poll);
    }, 400);
  } catch (err) { /* ignore */ }

})();



// // custom-date.js start
// document.addEventListener("DOMContentLoaded", function () {

//   const badgeWrappers = document.querySelectorAll(".product-badge-wrapper");

//   badgeWrappers.forEach(wrapper => {
//     const startDateStr = wrapper.dataset.start;
//     const endDateStr   = wrapper.dataset.end;
//     const badgeEl      = wrapper.querySelector(".product-badge");

//     if (!startDateStr || !endDateStr || !badgeEl) return;

//     const startDate = new Date(startDateStr).getTime();
//     const endDate   = new Date(endDateStr).getTime() + 24*60*60*1000; // include full end date
//     const oneDayMs  = 24*60*60*1000;

//     function updateBadge() {
//       const now = new Date().getTime();
//       const diffMs = endDate - now;

//       if (now < startDate) {
//         badgeEl.textContent = ""; // Not started yet
//         return;
//       }

//       if (diffMs <= 0) {
//         badgeEl.textContent = "Expired";
//         badgeEl.parentElement.className = "product-badge-wrapper product-badge--expired";
//         return;
//       }

//       const todayStr = new Date(now).toISOString().split("T")[0];
//       const startStr = new Date(startDate).toISOString().split("T")[0];
//       const endStr   = new Date(endDate - oneDayMs).toISOString().split("T")[0];

//       const daysLeft = Math.ceil(diffMs / oneDayMs);

//       // Case 1 → Start date
//       if (todayStr === startStr) {
//         badgeEl.textContent = "Limited time";
//         badgeEl.className = "product-badge product-badge--active";
//       }
//       // Case 2 → Last day
//       else if (todayStr === endStr) {
//         const hours = Math.floor((diffMs % oneDayMs) / (1000*60*60));
//         const minutes = Math.floor((diffMs % (1000*60*60)) / (1000*60));
//         const seconds = Math.floor((diffMs % (1000*60)) / 1000);
//         badgeEl.textContent = `⏰ Sale Ends In (${String(hours).padStart(2,"0")}:${String(minutes).padStart(2,"0")}:${String(seconds).padStart(2,"0")})`;
//         badgeEl.className = "product-badge product-badge--warning";
//       }
//       // Case 3 → 1 day remaining before last day
//       else if (daysLeft === 2) {
//         badgeEl.textContent = "⏰ 1 day left for Sale";
//         badgeEl.className = "product-badge product-badge--1-day-info";
//       }
//       // Case 4 → more than 1 day remaining
//       else if (daysLeft > 2) {
//         const endDateObj = new Date(endDate - oneDayMs);
//         const options = { year: 'numeric', month: 'short', day: 'numeric' };
//         badgeEl.textContent = `⏰ Sale Ends ${endDateObj.toLocaleDateString(undefined, options)}`;
//         badgeEl.className = "product-badge product-badge-all-info ";
//       }
//     }

//     updateBadge();
//     setInterval(updateBadge, 1000); // live update every second
//   });
// });
// // custom-date.js end
